<script lang="ts">
  import { fly } from "svelte/transition";
  import { ArrowFatRight } from "phosphor-svelte";
  import { page } from "$app/stores";
  import { notifications } from "$lib/data";
  import Notification from "./Notification.svelte";
  import { ws } from "$lib/websockets/connection";
  import { generate_notification_query } from "./notfication_data";
  const mark_as_seen = async (id: string) => {
    if (!$page.data.user) return;
    await fetch(`/api/notifications/mark_as_seen`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        notification_ids: [id],
        user: $page.data.user.id,
      }),
    });
  };

  $: uid = `notifications-${$page.data.user?.id}`;
  const collection = "user_notifications";

  const handle_click = async (e: CustomEvent) => {
    await mark_as_seen($notifications[e.detail.index].id);
    $notifications = $notifications.filter((_, i) => i !== e.detail.index);

    // if we have
    $ws?.send(
      JSON.stringify({
        type: "items",
        action: "read",
        collection,
        uid,
        query: generate_notification_query($page.data.user, false),
      }),
    );
  };
</script>

<div class="notifications">
  {#if $notifications.length > 5}
    <div class="more" out:fly={{ duration: 200, y: -25 }}>
      Showing 5 Latest Notifications
    </div>
  {/if}
  {#each $notifications as notification, index}
    {#if index < 5}
      {#if notification.item?.length}
        <Notification {notification} {index} on:clicked={handle_click} />
      {/if}
    {/if}
  {:else}
    <div class="none">No new notifications</div>
  {/each}
  <a href="/members/notifications">
    View {$notifications.length > 0 ? "All" : "Past"} Notifications
    <ArrowFatRight />
  </a>
</div>

<style>
  .more {
    padding: 0.5rem;
    font-size: 0.8rem;
    color: var(--offDark);
    text-align: center;
    font-family: "Open Sans";
    font-weight: 300;
  }

  .notifications {
    display: flex;
    flex-direction: column;
    font-size: 0.75rem;
    min-width: 250px;
    max-width: 300px;
  }
  .notifications .none {
    padding: 1rem;
  }
  .notifications a {
    background: var(--secondary);
    color: white;
    font-family: "Open Sans";
    font-size: .8rem;
    padding: 0.5rem 1rem;
    text-decoration: none;
    border-radius: 0.25rem;
    margin-top: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;


  }
</style>
